var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "black",
    fillOpacity: 0.09
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.254 10.9302H20.9834L17.206 15.2337L21.666 21.0694H18.1617L15.4311 17.5319L12.2909 21.0694H10.5615L14.6119 16.4729L10.334 10.9302H13.9293L16.4096 14.1747L19.254 10.9302ZM18.6396 20.0329H19.5953L13.4059 11.899H12.3592L18.6396 20.0329Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.29ac74b975d4e7a8e8b033570b8444c0.svg";
export { ForwardRef as ReactComponent };